import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";

const CustomSelectBox = ({ value, onChange, options = [], ...props }) => {
  const disabledOptions = ["retailer", "channel"];

  return (
    <FormControl
      sx={{
        maxWidth: 100,
        m: 0,
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .MuiOutlinedInput-root": {
          "& fieldset": { border: "none" },
          "&:hover fieldset": { border: "none" },
          "&.Mui-focused fieldset": { border: "none" },
        },
        "& .MuiSelect-select": {
          padding: "8px 0 8px 8px",
          fontWeight: 500,
          color: "#08306B",
          minWidth: 100,
          transition: "background 0.2s",
          whiteSpace: 'normal',
          overflow: 'hidden',
          wordBreak: 'break-word',
          lineHeight: 1.3,  
          display: 'block',
          "&:hover": {
            color: "#1976d2",
            background: "none",
            boxShadow: "none",
          },
        },
        "& .MuiSelect-icon": { color: "#08306B", right: 0 },
      }}
    >
      <Select
        value={value}
        onChange={onChange}
        sx={{
          marginTop: "8px",
          fontSize: "14px",
          fontWeight: "bold",
          borderRadius: "8px",
          height: 40,
          display: "flex",
          alignItems: "center",
          "& .MuiSelect-select": {
            padding: "10px 0px 10px 10px",  
          },
        }}
        {...props}
      >
        {options.map((option, index) => {
          const value = option.value ?? option;
          const label = option.label ?? option;

          return (
            <MenuItem
              key={index}
              value={value}
              disabled={disabledOptions.includes(value.toLowerCase())}
            >
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default CustomSelectBox;
